import React, {useState} from 'react';
import ResultListingBody from './resultListingBody';
// import ICONS from "assets/images/index.js";
import { Icon } from '../../helpers/icons';

const ResultDetails = ({test}) => {
    const [resultCollapse, setResultCollapse] = useState({});

    const togglResult = (lab_id) => {
        const val = resultCollapse[lab_id] ? false : true;
        setResultCollapse({...resultCollapse, [lab_id]: val});
    }

    return(
        <div key={test.id} className="items-center">
            <div className="flex justify-between items-center text-white bg-teal1000 hover:bg-primary-hover border-teal-c-800 border-l-4 mt-0.5 py-1.5 px-2.5 cursor-pointer" onClick={() => togglResult(test.id)}>
                <div className="flex flex-row items-center gap-x-2">
                    <Icon type="test_icon" />
                    <button>
                        <img src={resultCollapse[test.id] ? "" : "" } className="icon-w-14 icon-h-14"
                        alt="" />
                    </button>
                    <p className="font-normal text-base">
                        {`${test.codes ? test.codes+' - ' : ''}  ${test.desciption}`}
                    </p>
                </div>
            </div>
            {!resultCollapse[test.id] ?
                <div className='box-shadow'>
                    <ResultListingBody test={test} />
                </div>
                : null
            }
        
        </div>
    )
}

export default ResultDetails;